<template>
  <div
    v-show="show"
    class="modal fade"
    :class="[
      { 'show d-block': show },
      { 'd-none': !show },
      { 'modal-mini': type === 'mini' },
    ]"
    tabindex="-1"
    role="dialog"
    aria-label="modal"
    :aria-hidden="!show"
    @click.self="closeModal"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      :class="[{ 'modal-notice': type === 'notice' }, modalClasses]"
    >
      <div
        class="modal-content"
        :class="[
          gradient ? `bg-gradient-${gradient}` : '',
          modalContentClasses,
        ]"
      >
        <div v-if="$slots.header" class="modal-header" :class="[headerClasses]">
          <slot name="header"></slot>
          <slot name="close-button">
            <button
              v-if="showClose"
              type="button"
              class="close btn"
              :class="[headerButtonClasses]"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeAction"
            >
              <span :aria-hidden="!show"><i class="fa fa-times"></i></span>
            </button>
          </slot>
        </div>

        <div class="modal-body" :class="bodyClasses">
          <slot></slot>
        </div>

        <div v-if="$slots.footer" class="modal-footer" :class="footerClasses">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "modal",
  props: {
    show: Boolean,
    showClose: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "",
      validator(value) {
        let acceptedValues = ["", "notice", "mini"]
        return acceptedValues.indexOf(value) !== -1
      },
      description: "Modal type (notice|mini|\"\") ",
    },
    modalClasses: {
      type: [Object, String],
      description: "Modal dialog css classes",
    },
    modalContentClasses: {
      type: [Object, String],
      description: "Modal dialog content css classes",
    },
    gradient: {
      type: String,
      description: "Modal gradient type (danger, primary etc)",
    },
    headerClasses: {
      type: [Object, String],
      description: "Modal Header css classes",
    },
    headerButtonClasses: {
      type: [Object, String],
      description: "Modal Header Button css classes",
    },
    bodyClasses: {
      type: [Object, String],
      description: "Modal Body css classes",
    },
    footerClasses: {
      type: [Object, String],
      description: "Modal Footer css classes",
    },
    animationDuration: {
      type: Number,
      default: 500,
      description: "Modal transition duration",
    },
    dismissable: {
      type: Boolean,
      default: true,
      description: "Whether modal can be dismissed by clicking outside",
    }
  },
emits: ["update:show", "close"],
  watch: {
    show(val) {
      let documentClasses = document.body.classList
      if (val) {
        documentClasses.add("modal-open")
      } else {
        documentClasses.remove("modal-open")
      }
    },
  },
  methods: {
    closeAction(){
      this.$emit("update:show", false)
      this.$emit("close")
    },
    closeModal() {
      if (!this.dismissable) { return }
      this.$emit("update:show", false)
      this.$emit("close")
    },
  },
}
</script>
<style>
.modal.show {
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
